import * as api from "../Api";
import { loadFailed } from "../utils/errorMessage";

export const allLocationData = () => async (dispatch) => {
  try {
    const { data } = await api.locationData();
    dispatch({ type: "ALL_LOCATION_DATA", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};
